import parse from 'html-react-parser';
import React from 'react';

import ClampedText from '../switchback/ClampedText/ClampedText';

const Description = props => {
  const { description, introduction } = props;
  const introContent = introduction || description;
  return (
    <>
      {introContent && (
        <ClampedText
          paragraphClasses="w-full text-lg text-gray-900"
          buttonClassName="my-2 text-lg font-medium text-gray-800"
          clamp={4}
          readMore
          readLess
          underline={false}>
          {parse(introContent)}
        </ClampedText>
      )}
    </>
  );
};

export default Description;
